import { useQuery } from "@jti/rest-api";
import type { UserSubscriptionProduct } from "@jti/rest-api-types";

import { magento } from "../../clients/getClient";

import { getSubscriptionProductsSkus } from "./getSubscriptionProductsSkus";

export const useSubscriptionProductsDetails = (
  subscriptionUuid: string | undefined,
  products: UserSubscriptionProduct[] | undefined = []
) => {
  const skus = getSubscriptionProductsSkus(products);

  return useQuery(
    ["USE_SUBSCRIPTION_PRODUCTS_DETAILS", subscriptionUuid, ...skus],
    () => magento.CUSTOM_TYPES_BETA__getProductsDetailsBySku(skus, skus.length),
    {
      enabled: !!subscriptionUuid && skus.length > 0,
    }
  );
};
